import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import 'rxjs/add/operator/finally';

import { UserSession } from '@mem-shared/user-session';
import { NativeIntegrationService } from '@mem-shared/native-integration.service';
import { UtilService } from '@mem-shared/util.service';
import { NewLoginWidgetService } from "../new-login-widget.service";
@Component({
  selector: 'mem-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {
  loading: boolean;
  accountId;
  subscriberId;
  redirectToMosWeb;
  isInternalUser: boolean = false;
  CFIMPSORIGINCookie;
  constructor(
    private userSession: UserSession,
    private oktaLoginSvc: NewLoginWidgetService,
    private route: ActivatedRoute,
    private router: Router,
    private cookieService: CookieService,
    private nativeSvc: NativeIntegrationService,
    private utilSvc: UtilService
  ) {
    // need to call in constructor so that data is
    // cleared before mega-menu tries to access it.
    if (this.userSession.getMemberAccountDetails()) {
      this.redirectToMosWeb = this.userSession.getMemberAccountDetails().memberAccountDetails.find(account => {
        return account.redirectToMosweb == true;
      })
    }
    this.accountId = this.userSession.getCurrentAccountId();
  //oldline  // this.subscriberId = this.userSession.getMemberAccountDetails().memberKey.subscriberId;
   this.subscriberId = this.userSession.getMemberAccountDetails()?this.userSession.getMemberAccountDetails().memberKey.subscriberId:'';
    this.CFIMPSORIGINCookie = this.userSession.getCookie('CF-IMPS-ORIGIN');
    this.userSession.clearData();
  }

  ngOnInit() {

    const w: any = window;
    w.mfaInit();

    this.oktaLoginSvc.trackGAEvent("OKTA-Logout","OKTA-Logout")
    this.loading = true;

    this.oktaLoginSvc.callNativeForTouchId = 0;
    this.route.params.subscribe(({ ebiz }) => {
      if (ebiz) {
        if (this.CFIMPSORIGINCookie) {
          window.location.href = this.getMosAdminUrl();
        } else {
          window.location.href = this.getEbizUrl();
        }
        // If it is not Ebiz user or redirected user, loading is set to false to display logout page
      } else {
        // this.oktaLoginSvc
        //   .logout(this.accountId)
        //   .finally(() => {
            let lnCookie = this.cookieService.get("ln");
            this.clearCookies();          
            this.cookieService.deleteAll();
            this.cookieService.set("ln",lnCookie);
            // if we are on native app redirect to
            // native landing page
            if (this.utilSvc.getNativeOS() === 'iOS' || this.utilSvc.getNativeOS() === 'Android') {

              //alert('You are in logout page');
              const urlPreLogin = window.location.protocol + '//' +
                window.location.host + window.location.pathname + '/../assets/native-app-static/prelogin.html';

              //window.location.replace(CFHttpClient.targetURL + environment.applicationRoot + '/assets/native-app-static/prelogin.html');
           /// alert(urlPreLogin);
            //   window.location.replace(urlPreLogin); 
            }
            // else {
        this.loading = false;
        //this.oktaLoginSvc.logout(this.accountId);
        this.oktaLoginSvc.oktaSpgwLogout();
          //   }
          // }).subscribe()
      }
      // error => {
      //   this.loading = false;
      // }

    });
  }

  clearCookies() {
    if (this.utilSvc.getNativeOS() !== 'web') {
      this.nativeSvc.invokeNativeService(this.utilSvc.getNativeOS(), 'clearCookie', null);
    }
  }

  goPublicHome() {
    const env = this.utilSvc.getEnvName();
    const zenv = this.userSession.getSession('zenv');

    if (this.userSession.getLocalStorageItem('sourcePortal') == 'MEMBER') {
      window.location.href = window.location.origin;
    } else {
      if (env === 'tt') {
        if (zenv && zenv === 'sit') {
          window.location.href = 'https://carefirstmedicaresp.sit.crfs.use1.iws-nonprod.zipari.net';
        } else {
          window.location.href = 'https://carefirstmedicaresp.pit.crfs.use1.iws-nonprod.zipari.net';
        }
      }
      else if (env === 'uat') {
        if (zenv && zenv === 'prod') {
          window.location.href = 'https://shop.carefirst.com';
        } else {
          window.location.href = 'https://shop-uat.carefirst.com';
        }
      }
      else {
        window.location.href = 'https://shop.carefirst.com';
      }
    }

  }
  goToLogin() {
    this.router.navigate(['/login'], { queryParams: { sourcePortal: this.userSession.getLocalStorageItem('sourcePortal') } });
  }

  private getEbizUrl() {
    if (window.document.referrer && window.document.referrer != "") { // Chrome flow 
        return window.document.referrer

      } else if (window.document.referrer == "" &&  this.subscriberId) {   // IE & Firefox Flow; The referring URL is not saved from IE & Firefox. It will be "".
      // We will construct the URL manually in order to go back to the member's details in eBiz.
      // First check for production or testing URLS.
      let domain;

      if (this.utilSvc.getEnvName().toLowerCase() === 'prod') {
        domain = `https://member`;
      } else {
        domain = `https://member${this.utilSvc.getEnvName()}`;
      }
      // Then concatenate with a query parameter.
      return `${domain}.carefirst.com/secure/eBizAdmin/member-admin/users/UserInquiry.do?memberId=${this.subscriberId}`;

    } else {  // To catch unknown situations, redirect to the member search on eBiz
      // Adding condition to check for prod environment to redirect the user back to ebiz accordingly
      if (this.utilSvc.getEnvName().toLowerCase() === 'prod') {
        return `https://member.carefirst.com/secure/eBizAdmin/member-admin/users/MemberSearchDisplay.do`;
      } else {
        return `https://member${this.utilSvc.getEnvName()}.carefirst.com/secure/eBizAdmin/member-admin/users/MemberSearchDisplay.do`;
      }
    }
  }

  private getMosAdminUrl() {
    // Adding condition to check for prod environment to redirect the user back to mosadmin accordingly
    if (this.utilSvc.getEnvName().toLowerCase() === 'prod') {
      return `https://webapp.carefirst.com/mosadmin`;
    } else {
      return `https://webapp${this.utilSvc.getEnvName()}.carefirst.com/mosadmin`;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/new-login-widget/logout/logout.component.ts